import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchParcelStylesApiRequest } from '../../../types/requests/parcel-styles/search-parcel-styles.request';
import { ParcelStyleApiModel } from '../../../types/models/parcel-style.model';

export const searchParcelStyles = <T extends ParcelStyleApiModel>(params: SearchParcelStylesApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/parcel-styles`, { params });
